var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_1793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05108 11.9491C1.38251 11.3034 0.849233 10.5309 0.48237 9.67691C0.115507 8.82288 -0.0775965 7.90434 -0.0856732 6.97489C-0.0937499 6.04543 0.083362 5.12368 0.435328 4.2634C0.787294 3.40313 1.30707 2.62156 1.96431 1.96431C2.62156 1.30707 3.40313 0.787294 4.2634 0.435328C5.12368 0.083362 6.04543 -0.0937499 6.97489 -0.0856732C7.90434 -0.0775965 8.82288 0.115507 9.67691 0.48237C10.5309 0.849233 11.3034 1.38251 11.9491 2.05108C13.2242 3.3713 13.9297 5.13951 13.9138 6.97489C13.8978 8.81027 13.1617 10.566 11.8638 11.8638C10.566 13.1617 8.81027 13.8978 6.97489 13.9138C5.13951 13.9297 3.3713 13.2242 2.05108 11.9491ZM10.9621 10.9621C12.0129 9.91129 12.6032 8.48612 12.6032 7.00008C12.6032 5.51404 12.0129 4.08887 10.9621 3.03808C9.91129 1.98729 8.48612 1.39697 7.00008 1.39697C5.51404 1.39697 4.08887 1.98729 3.03808 3.03808C1.98729 4.08887 1.39697 5.51404 1.39697 7.00008C1.39697 8.48612 1.98729 9.91129 3.03808 10.9621C4.08887 12.0129 5.51404 12.6032 7.00008 12.6032C8.48612 12.6032 9.91129 12.0129 10.9621 10.9621ZM6.30008 7.70008V6.30008H7.70008V10.5001H6.30008V7.70008ZM6.30008 3.50008H7.70008V4.90008H6.30008V3.50008Z",
    fill: "#2361FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_1793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescLeftIcon);
export default __webpack_public_path__ + "static/media/desc-left-icon.f1dfc7713ccc75bdeadbe56f8f336614.svg";
export { ForwardRef as ReactComponent };